import { environment } from '../environments/environment';

export const APP_STATE_KEY = environment.app_state_key;

/**
 * Removes legacy NgRx snapshot from localStorage (`app_storage`).
 * Catalog data (forms, tags, attributes, config) must come from the API per session.
 */
export function clearLegacyAppStorage(): void {
  try {
    localStorage.removeItem(APP_STATE_KEY);
  } catch {
    /* ignore quota / private mode */
  }
}

/** @deprecated Use clearLegacyAppStorage */
export function purgeAuthFromLocalStorage(): void {
  clearLegacyAppStorage();
}
